import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <Link to="/signup" className="back-link">
          ← 新規登録に戻る
        </Link>
        <h1>利用規約・プライバシーポリシー</h1>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <h2>利用規約</h2>
          
          <p className="section-intro">
            この利用規約（以下「本規約」）は、本アプリ「山のぼろ」（以下「本サービス」）の利用条件を定めるものです。ユーザーの皆さまには、本規約に同意の上、本サービスをご利用いただきます。
          </p>

          <div className="terms-article">
            <h3>第1条（適用）</h3>
            <p>本規約は、ユーザーと本サービス運営者「ヤマノメディア編集局」（以下「運営者」）との間の、本サービスの利用に関わる一切の関係に適用されます。</p>
          </div>

          <div className="terms-article">
            <h3>第2条（利用登録）</h3>
            <p>本サービスの利用を希望する方は、本規約に同意の上、運営者の定める方法により利用登録を行うものとします。</p>
            <p>登録内容に虚偽があった場合、運営者は登録を取り消すことがあります。</p>
          </div>

          <div className="terms-article">
            <h3>第3条（アカウント管理）</h3>
            <p>ユーザーは、自己の責任においてアカウント情報を管理するものとします。</p>
            <p>第三者による不正利用について、運営者は一切の責任を負いません。</p>
          </div>

          <div className="terms-article">
            <h3>第4条（禁止事項）</h3>
            <p>ユーザーは、以下の行為をしてはなりません。</p>
            <ul>
              <li>法令または公序良俗に違反する行為</li>
              <li>虚偽の募集・応募情報の掲載</li>
              <li>他のユーザーへの嫌がらせ、誹謗中傷</li>
              <li>営利・勧誘・宗教・政治目的での利用</li>
              <li>無断での個人情報収集・公開</li>
              <li>システムへの不正アクセス</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>第5条（募集・応募に関する注意）</h3>
            <p>本サービスは登山メンバー募集の「情報共有・マッチングの場」を提供するものであり、登山行為そのものの安全性、成功、結果を保証するものではありません。</p>
            <p>登山は天候急変、滑落、落石、体調不良、装備不足等の重大な危険を伴う行為であり、参加・実施の判断はすべてユーザー自身の責任で行うものとします。</p>
            <p>天候判断、ルート選定、装備の準備、体力・経験の見極めは各自の責任とし、募集内容や他ユーザーの情報を根拠に安全が保証されるものではありません。</p>
            <p>登山中および集合・解散前後を含むすべての行動において発生した事故、怪我、トラブル、損害について、運営者は一切の責任を負いません。</p>
            <p>ユーザー同士のやり取り、合流・同行の判断は自己責任で行ってください。</p>
          </div>

          <div className="terms-article">
            <h3>第6条（コンテンツの取り扱い）</h3>
            <p>ユーザーが投稿した募集内容・プロフィール情報等の権利はユーザーに帰属しますが、本サービスの運営・広報の範囲で無償利用できるものとします。</p>
          </div>

          <div className="terms-article">
            <h3>第7条（利用停止・削除）</h3>
            <p>運営者は、ユーザーが本規約に違反した場合、事前通知なく利用停止またはアカウント削除を行うことができます。</p>
          </div>

          <div className="terms-article">
            <h3>第8条（免責事項）</h3>
            <p>本サービスの内容変更・中断・停止により生じた損害について、運営者は責任を負いません。</p>
            <p>ユーザー間のトラブルについて、運営者は関与せず責任を負いません。</p>
          </div>

          <div className="terms-article">
            <h3>第9条（規約の変更）</h3>
            <p>運営者は、必要と判断した場合、本規約を変更できるものとします。</p>
          </div>

          <div className="terms-article">
            <h3>第10条（準拠法・管轄）</h3>
            <p>本規約は日本法に準拠し、本サービスに関する紛争は運営者所在地を管轄する裁判所を専属的合意管轄とします。</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>プライバシーポリシー</h2>
          
          <p className="section-intro">
            本ポリシーは、「山のぼろ」（運営者：ヤマノメディア編集局）における個人情報の取り扱いについて定めるものです。
          </p>

          <p>運営者は、本サービスにおけるユーザーの個人情報を以下の方針に基づき取り扱います。</p>

          <div className="terms-article">
            <h3>1. 取得する情報</h3>
            <ul>
              <li>メールアドレス</li>
              <li>ニックネーム</li>
              <li>プロフィール情報（自己紹介、登山歴、リンク等）</li>
              <li>募集・応募に関する投稿情報</li>
              <li>Firebase Authentication により発行されるユーザー識別情報</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>2. 利用目的</h3>
            <p>取得した情報は以下の目的で利用します。</p>
            <ul>
              <li>本サービスの提供・運営</li>
              <li>本人確認・認証</li>
              <li>不正利用防止</li>
              <li>お問い合わせ対応</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>3. 個人情報の管理</h3>
            <p>運営者は、Firebase（Google LLC）の提供するセキュリティ機能を利用し、個人情報を適切に管理します。</p>
          </div>

          <div className="terms-article">
            <h3>4. 第三者提供</h3>
            <p>法令に基づく場合を除き、ユーザーの同意なく第三者に個人情報を提供しません。</p>
          </div>

          <div className="terms-article">
            <h3>5. 外部サービスの利用</h3>
            <p>本サービスは以下の外部サービスを利用しています。</p>
            <ul>
              <li>Firebase Authentication</li>
              <li>Firebase Firestore</li>
            </ul>
            <p>これらのサービスは各提供事業者のプライバシーポリシーに基づき管理されます。</p>
          </div>

          <div className="terms-article">
            <h3>6. 個人情報の開示・削除</h3>
            <p>ユーザーは、プロフィール画面より個人情報の編集・削除、アカウント削除を行うことができます。</p>
          </div>

          <div className="terms-article">
            <h3>7. プライバシーポリシーの変更</h3>
            <p>本ポリシーは、必要に応じて変更されることがあります。</p>
          </div>

          <div className="terms-article">
            <h3>8. お問い合わせ</h3>
            <p>本ポリシーに関するお問い合わせは、アプリ内のお問い合わせ手段よりご連絡ください。</p>
          </div>
        </section>

        <div className="terms-footer">
          <p><strong>制定日：2026年1月</strong></p>
          <p><strong>運営者：ヤマノメディア編集局</strong></p>
          
          <div className="terms-footer-actions">
            <Link to="/signup" className="btn btn-outline">
              新規登録に戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
